/*
 * 工单数据--故障场站TOP20排名--故障设备明细
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import ScGridTable from "@/components/display/table/gridTableCore";
import { queryFaultStationDetail } from "@/fetch/fetchApi";

class FaultDevice extends Component {
  state = {
    tableConfig: null,
  };

  componentWillMount() {
    // console.log("FaultDevice componentWillMount", this.props);
    const modalParam = this.context.store.getState().modalInfo.param;
    this.setState({
      tableConfig: {
        tableKey: "faultDeviceTable",
        tableColumns: [
          {
            name: "场站名称",
            key: "stationName",
            colType: "textCol",
            align: "center",
          },
          {
            name: "设备编号",
            key: "targetId",
            colType: "textCol",
            align: "center",
          },
          {
            name: "故障工单数",
            key: "faultTicketNum",
            colType: "textCol",
            align: "center",
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          ...modalParam,
        },
        dataApi: queryFaultStationDetail,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    return <ScGridTable config={this.state.tableConfig} />;
  }
}

export default FaultDevice;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/detail/faultDevice.js